<template>
    <div class="shop-wrapper">
        <div id="edit-account-page" class="section">
            <!-- Container -->
            <div class="container">

              
                <!-- Edit Account -->
                <div class="columns account-header">
                    <div class="column main-column">
                        <div class="account-title">
                            <h2>EDICION DE USUARIO</h2>
                            <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="brand-filigrane">
                        </div>

                        <!-- Account tabs -->
                        <div class="tabs account-tabs">
                            <navigation></navigation>
                        </div>

                        <!-- Edit Account Layout -->
                        <div id="account-edit-main" class="columns is-account-grid is-multiline">
                            <!--Loader-->
                            <div class="account-loader is-active is-hidden">
                                <div class="loader is-pulled-lg is-loading"></div>
                            </div>
                            <div class="column is-4">
                                <div class="flat-card upload-card is-auto">
                                    <div class="card-body">
                                        <div id="avatar-upload" class="avatar-wrapper has-simple-popover" data-content="Change profile picture" data-placement="top">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user profile-pic"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        </div>
                                        <!-- User -->
                                        <div class="username has-text-centered">
                                            <span id="full-name">{{user.name}}</span>
                                            <span id="full-email">{{user.email}}</span>
                                        </div>

                                        <div class="has-text-centered pop-button">
                                            <button id="save-account-button" class="button feather-button primary-button is-rounded raised opaque"
                                                :disabled="this.form.password != this.form.password_confirmation"
                                                @click.prevent="submit">
                                                GUARDAR CAMBIOS
                                            </button>
                                        
                                            <div class="p1"></div>
                                            <div class="p2"></div>
                                            <div class="p3"></div>
                                            <div class="p4"></div>
                                            <div class="p5"></div>
                                            <div class="p6"></div>
                                            <div class="p7"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-8">

                                <!-- Edit contact Info -->
                                <div class="flat-card profile-info-card is-auto">
                                    <!-- Title -->
                                    <div class="card-title">
                                        <h3>Información de Usuario</h3>
                                        <!-- Save button -->
                                        <div class="confirm-button is-vhidden">
                                            <a href="javascript:void(0);" role="button" class="has-simple-popover" data-content="Save Contact info" data-placement="top"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check feather-icons"><polyline points="20 6 9 17 4 12"></polyline></svg></a>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <div class="field info-block has-flex-label has-validation">
                                                    <label class="label-text">
                                                        <span>Nombre</span>
                                                        <span class="error">Minimum 2 characters</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="edit-first-name" type="text" class="input is-default fake-validation" v-model="user.name">
                                                    </div>
                                                </div>

                                                <div class="field info-block has-flex-label has-validation">
                                                    <label class="label-text">
                                                        <span>Correo</span>
                                                        <span class="error">Enter a valid email</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="edit-email" type="email" class="input is-default fake-email-validation" v-model="user.email">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="column is-6">
                                                <div class="field info-block has-flex-label has-validation">
                                                    <label class="label-text">
                                                        <span>Apellido</span>
                                                        <span class="error">Minimum 2 characters</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="edit-last-name" type="text" class="input is-default fake-validation" v-model="user.lastname">
                                                    </div>
                                                </div>

                                                <div class="field info-block has-flex-label">
                                                    <label class="label-text">
                                                        <span>Teléfono</span>
                                                        <span class="error">Minimum 2 characters</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="edit-phone-number" type="text" class="input is-default" v-model="user.celular">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Edit contact Info -->
                                <!-- Edit password -->
                                <div class="flat-card profile-info-card is-auto">
                                    <!-- Title -->
                                    <div class="card-title">
                                        <h3>Modificar Contraseña</h3>
                                        <!-- Save button -->
                                        <div class="confirm-button is-vhidden">
                                            <a href="javascript:void(0);" role="button" class="has-simple-popover" data-content="Save Contact info" data-placement="top"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check feather-icons"><polyline points="20 6 9 17 4 12"></polyline></svg></a>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <div class="field info-block has-flex-label has-validation">
                                                    <label class="label-text">
                                                        <span>Contraseña</span>
                                                        <span class="error">Minimum 2 characters</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="password" type="password" class="input is-default fake-validation" v-model="form.password">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="column is-6">
                                                <div class="field info-block has-flex-label has-validation">
                                                    <label class="label-text">
                                                        <span>Repetir Contraseña</span>
                                                        <span class="error">Minimum 2 characters</span>
                                                    </label>
                                                    <div class="control">
                                                        <input id="password_confirmation" type="password" class="input is-default fake-validation" v-model="form.password_confirmation">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Edit password -->

                            </div>
                        </div>
                    </div>
                </div>
                <!-- /Edit Account -->
            </div>
            <!-- /Container -->
        </div>   
    </div>   
</template>

<script>
import { mapGetters, mapActions } from 'vuex' 
import navigation from '../components/navigation'

export default {
    name: 'account-form',
    data(){
        return{
            form:{
                password: '',
                password_confirmation: '',
                name: '',
                lastname: '',
                email: '',
                celular: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
        }),
    },
    methods:{
        ...mapActions({
            updateUser: 'auth/updateUser',
        }),
        submit(){
            
            this.form.name     = this.user.name;
            this.form.lastname = this.user.lastname;
            this.form.email    = this.user.email;
            this.form.celular  = this.user.celular;

            this.updateUser(this.form)
                .then(() => {
                    this.form.password = '';
                    this.form.password_confirmation = '';
                }).catch(() => {
                    console.log("Fallo al guardar!");
                })
        },
    },
    components:{
        navigation
    }
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px;
}
.table-wrapper{
    overflow-x: auto;
}

.pagination > button, .pagination ul li > button {
    cursor: pointer;
}
.m-t-r{
    margin: 0.75rem 0.75rem 0;
}

/* svg.svg-button{
    width: 18px;
    height: 18px;
    -webkit-transition: all .3s;
    transition: all .3s;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    stroke-width: 1.2px;
}

.pagination-link.is-current {
    color: #fff;
    background-color: #009BDB;
    border: 2px solid #009BDB;
}
.card-footer{
    margin-top: 30px;
}
.pagination-previous, .pagination-next, .pagination-link {
    color: #009BDB;
    border: 2px solid #009BDB;
    background: none;
}
.pagination-previous:not([disabled]):hover, .pagination-next:not([disabled]):hover, .pagination-link:hover {
    color: #009BDB;
    border: 2px solid #009BDB;
    background-color: #dbdbdb;
} */
</style>